// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-title__text[data-v-764718da]{font-weight:700;font-size:28px;line-height:40px;letter-spacing:.5px}.close-dialog__icon[data-v-764718da]{cursor:pointer;align-self:start}[data-v-764718da] .v-toolbar__content{padding-right:0}.save-btn[data-v-764718da]{width:200px;max-width:200px}.close-btn[data-v-764718da],.save-btn[data-v-764718da]{border-radius:35px;font-size:13px}.close-btn[data-v-764718da]{text-decoration:underline;font-weight:700;letter-spacing:.5px}", ""]);
// Exports
module.exports = exports;
